// deps
import React, { ReactElement, memo } from "react";
// internal-deps
import { RouteProps } from "@swiggy-private/core-ui";
import { CheckoutRoute } from "@swiggy-private/checkout-core";
// components
import { CouponListing } from "@cart-client/components/coupon-listing/CouponListing";

type CouponListingProps = RouteProps<CheckoutRoute>;

const GiftingCouponListing = (props: CouponListingProps): ReactElement | null => {
    // reusing coupon listing component for gifting cart
    // it is just mounted on GIFTING_COUPON_LISITNG route
    return <CouponListing {...props} />;
};

export default memo(GiftingCouponListing);
